










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobServiceForm } from '@/models/jobServiceForm/jobServiceForm';
import { JobServiceFormRequest } from '@/models/jobServiceForm/jobServiceFormRequest';
import OptionSelector from '@/components/common/OptionSelector.vue';
import Nullable from '@/types/nullable';

@Component({
  components: {
    OptionSelector
  }
})
export default class JobServiceFormEdit extends Vue {
  @Prop({ type: Object, default: null }) public data!: JobServiceFormRequest;
  @Prop({ type: Object, default: null }) public loadedForm!: Nullable<JobServiceForm>;
  private expanded: boolean = false;

  get yesNoOptions() {
    return [
      {
        id: 1,
        name: "Yes"
      },
      {
        id: 2,
        name: "No"
      }
    ];
  }

  get yesNoNAOptions() {
    return this.yesNoOptions.concat([
      {
        id: 3,
        name: "N/A"
      }
    ]);
  }
}

